import { render, staticRenderFns } from "./rp-roles-datasources-list-cruds.vue?vue&type=template&id=12b2a012"
import script from "./rp-roles-datasources-list-cruds.vue?vue&type=script&lang=js"
export * from "./rp-roles-datasources-list-cruds.vue?vue&type=script&lang=js"
import style0 from "./rp-roles-datasources-list-cruds.vue?vue&type=style&index=0&id=12b2a012&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports